{
  "name": "@auto-orbit/app",
  "private": true,
  "version": "1.0.0",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "vite build --mode production",
    "preview": "vite preview",
    "lint": "eslint .",
    "lint:fix": "eslint --fix .",
    "shutdown": "kill -9 `lsof -t -i:3000`",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "storybook build"
  },
  "dependencies": {
    "@fontsource-variable/geist": "^5.2.9",
    "@fontsource-variable/geist-mono": "^5.2.8",
    "@hookform/resolvers": "^5.4.0",
    "@radix-ui/react-dialog": "^1.1.16",
    "@radix-ui/react-label": "^2.1.9",
    "@radix-ui/react-popover": "^1.1.16",
    "@radix-ui/react-slot": "^1.2.5",
    "@radix-ui/react-switch": "^1.3.0",
    "@radix-ui/react-tabs": "^1.1.14",
    "@sentry/react": "^10.56.0",
    "@stripe/react-stripe-js": "^3.9.0",
    "@stripe/stripe-js": "^4.0.0",
    "@tanstack/react-query": "^5.101.0",
    "@tanstack/react-router": "^1.170.12",
    "@tanstack/react-table": "^8.21.3",
    "axios": "^1.17.0",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "date-fns": "^4.4.0",
    "immer": "^11.1.8",
    "lodash": "^4.18.1",
    "lucide-react": "^1.17.0",
    "react": "^19.2.7",
    "react-dom": "^19.2.7",
    "react-hook-form": "^7.77.0",
    "tailwind-merge": "^3.6.0",
    "yup": "^1.7.1"
  },
  "devDependencies": {
    "@chromatic-com/storybook": "^5.2.1",
    "@eslint/js": "^9.39.4",
    "@sentry/vite-plugin": "^5.3.0",
    "@storybook/addon-onboarding": "^10.4.2",
    "@storybook/react": "^10.4.2",
    "@storybook/react-vite": "^10.4.2",
    "@stylistic/eslint-plugin": "^5.10.0",
    "@tailwindcss/vite": "^4.3.1",
    "@tanstack/eslint-plugin-query": "^5.101.0",
    "@tanstack/react-query-devtools": "^5.101.0",
    "@tanstack/react-router-devtools": "^1.167.0",
    "@tanstack/router-plugin": "^1.168.15",
    "@types/react": "^19.2.17",
    "@types/react-dom": "^19.2.3",
    "@vitejs/plugin-react": "^6.0.2",
    "@vitest/browser": "^4.1.8",
    "@vitest/coverage-v8": "^4.1.8",
    "eslint": "^9.39.4",
    "eslint-plugin-lube": "^0.5.1",
    "eslint-plugin-perfectionist": "^4.15.1",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-react-refresh": "^0.5.2",
    "eslint-plugin-storybook": "^10.4.2",
    "globals": "^17.6.0",
    "http-proxy": "^1.18.1",
    "playwright": "^1.60.0",
    "prop-types": "^15.8.1",
    "storybook": "^10.4.2",
    "tailwindcss": "^4.3.1",
    "tw-animate-css": "^1.4.0",
    "vite": "^8.0.16",
    "vite-plugin-compression2": "^2.5.3",
    "vitest": "^4.1.8"
  },
  "eslintConfig": {
    "extends": [
      "plugin:storybook/recommended"
    ]
  }
}
